// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "ad4b9bfa4cdd2a9fc2e8" + ".css";
};